import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import {Action, handleAsyncActions} from 'redux/helpers';
import types, {serverKey} from './types';

export const serverInitialState = {
   isFetching: false,
   error: null,
   separator: '\\',

   [types.DOWNLOAD_CONNECTION_AUDIT_REPORT._FETCHING]: false,
   [types.DOWNLOAD_CONNECTION_AUDIT_REPORT._ERROR]: null,
};

const reducer = (_state = serverInitialState, action: Action) => {
   const state = handleAsyncActions(_state, action, types);
   switch (action.type) {
      case types.GET_PATH_SEPARATOR.SUCCESS:
         return {
            ...state,
            separator: action.payload.separator,
         };
      default:
         return state;
   }
};

let _reducer = reducer;
if (process.env.REACT_APP_PERSISTED === 'true') {
   const config = {
      key: serverKey,
      storage: storage,
      blacklist: ['error', 'isFetching'],
   };
   _reducer = persistReducer(config, reducer) as any;
}
export default _reducer;
